import { render, staticRenderFns } from "./FaqQuestions.vue?vue&type=template&id=263f2b86"
import script from "./FaqQuestions.vue?vue&type=script&lang=ts"
export * from "./FaqQuestions.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports